import React, { useState, useEffect } from "react";


const ToggleButton = ({isChecked, handleIsCheckedChange}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id="toggleButton"
        className="hidden"
        checked={isChecked}
        onChange={handleIsCheckedChange}
      />
      <label
        htmlFor="toggleButton"
        className="relative flex items-center cursor-pointer select-none"
      >
        <div className={`w-12 h-6 rounded-full shadow-inner  border-2
        ${
          isChecked ? 'border-green-400' : 'border-red-400'
        }
        `}></div>
        <div
          className={`toggle-dot absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform ${
            isChecked ? 'ml-6 bg-green-400 ' : 'ml-0 bg-red-400 '
          }`}
        ></div>
      </label>
    </div>
  );
};


const EditFeatureFlagForm = (props) => {

  const [isChecked, setIsChecked] = useState(props.feature_flag.enabled);



  const handleIsCheckedChange = () => {
    setIsChecked(!isChecked);
  };



  return (
    <div>
      <div className="grid sm:grid-cols-6 gap-4 grid-cols-1 w-full items-center">

        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap">Feature Name*</h3>
        </div> 

        <div className="sm:col-span-4 col-span-1">
            <h3 className="whitespace-nowrap">{props.feature_flag.name}</h3>
        </div>
        
        <div className="sm:col-span-2 col-span-1">
          <h3 className="whitespace-nowrap pr-6">Enabled</h3>
        </div>
        
        <div className="w-full sm:col-span-4 col-span-1">
            <ToggleButton 
              isChecked={isChecked}
              handleIsCheckedChange={handleIsCheckedChange}
            />

            <input type="hidden"  id="feature_flag_enabled" name="feature_flag[enabled]" value={isChecked? 1:0}/>
        </div>


      </div>
      
    </div>
  );
};


export default EditFeatureFlagForm;